module.exports = __webpack_public_path__ + "img/nohem-gold.23abcd68.png";